module.exports = __webpack_public_path__ + "static/media/hqv_rotate_finger.77ce7e0d.gif";